import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-02f25ef7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "service-wrap ptb-100" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "blog-card style1" }
const _hoisted_5 = { class: "blog-img" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "blog-info blockRecadrer" }
const _hoisted_8 = { class: "blog-metainfo list-style" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-user" }, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-calendar" }, null, -1))
const _hoisted_11 = { class: "titleH3" }
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-right-arrow" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.articles, (article, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "col-xl-4 col-lg-6 col-md-6",
            key: index
          }, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("img", {
                  src: _ctx.getUrlApiForFiles(article.urlImage),
                  alt: "Image",
                  class: "blogimg"
                }, null, 8, _hoisted_6)
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("ul", _hoisted_8, [
                  _createElementVNode("li", null, [
                    _hoisted_9,
                    _createVNode(_component_router_link, { to: "/posts-by-author" }, {
                      default: _withCtx(() => [
                        _createTextVNode("La Poste du Bénin SA")
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("li", null, [
                    _hoisted_10,
                    _createTextVNode(_toDisplayString(_ctx.format_date(article.datePublication)), 1)
                  ])
                ]),
                _createElementVNode("h3", _hoisted_11, [
                  _createVNode(_component_router_link, {
                    to: { name: 'ViewArticlePage', params: { id: article.id } }
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(article.titre), 1)
                    ]),
                    _: 2
                  }, 1032, ["to"])
                ]),
                _createElementVNode("div", {
                  class: "truncate-text",
                  innerHTML: article?.contenu
                }, null, 8, _hoisted_12),
                _createVNode(_component_router_link, {
                  to: { name: 'ViewArticlePage', params: { id: article.id } },
                  class: "link style1 lireplus"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Lire plus "),
                    _hoisted_13
                  ]),
                  _: 2
                }, 1032, ["to"])
              ])
            ])
          ]))
        }), 128))
      ])
    ])
  ]))
}